export class BreadCrumb {
    public Label: string;
    public Url: string;
}